<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <g id="Group_3269" data-name="Group 3269" transform="translate(-1338 -6381)">
    <g id="Group_2_Copy_3" data-name="Group 2 Copy 3" transform="translate(1338 6381)">
      <g id="Group_13_Copy" data-name="Group 13 Copy">
        <rect id="Rectangle_Copy" data-name="Rectangle Copy" width="32" height="32" rx="2" fill="#fff" opacity="0.3"/>
      </g>
    </g>
    <g id="instagram" transform="translate(1344 6387)">
      <path id="Path_1281" data-name="Path 1281" d="M15,0H5A4.951,4.951,0,0,0,0,5V15a4.951,4.951,0,0,0,5,5H15a4.951,4.951,0,0,0,5-5V5A4.951,4.951,0,0,0,15,0Zm3,15a2.946,2.946,0,0,1-3,3H5a2.946,2.946,0,0,1-3-3V5A2.946,2.946,0,0,1,5,2H15a2.946,2.946,0,0,1,3,3Z" fill="#fff"/>
      <path id="Path_1282" data-name="Path 1282" d="M10,5a5,5,0,1,0,5,5A4.951,4.951,0,0,0,10,5Zm0,8a2.946,2.946,0,0,1-3-3,2.946,2.946,0,0,1,3-3,2.946,2.946,0,0,1,3,3A2.946,2.946,0,0,1,10,13Z" fill="#fff"/>
      <circle id="Ellipse_24" data-name="Ellipse 24" cx="1" cy="1" r="1" transform="translate(14 4)" fill="#fff"/>
    </g>
  </g>
</svg>
